
// Cache selectors that won't change
const shippingBtnSelector = ".product__info-container .free-shipping-text";
const simpleOptionBtnSelector = ".product__info-container .one-time-purchase-labels legend.form__label";
const variantValuesSelector = '.template--lander-one .product__info-container .product-form__input--pill input[type=radio]+label';
const buyButton_variants = '.template--lander-one .buy-buttons';

let shippingBtn, simpleOptionBtn, subscriptionWidget;

function initializeElements() {
  shippingBtn = document.querySelector(shippingBtnSelector);
  simpleOptionBtn = document.querySelector(simpleOptionBtnSelector);
  buyButton_and_variants = document.querySelector(buyButton_variants);
  subscriptionWidget = document.querySelector(".appstle_sub_widget");
  
  if (shippingBtn && simpleOptionBtn && subscriptionWidget) {
    setupEventListeners();
  }
}

function setupEventListeners() {
  // Remove existing listeners to prevent duplicates
  shippingBtn.replaceWith(shippingBtn.cloneNode(true));
  simpleOptionBtn.replaceWith(simpleOptionBtn.cloneNode(true));
  
  // Reassign elements after clone
  shippingBtn = document.querySelector(shippingBtnSelector);
  simpleOptionBtn = document.querySelector(simpleOptionBtnSelector);
  
  shippingBtn.addEventListener('click', (e) => {
    console.log('Shipping click event working');
    simpleOptionBtn.classList.remove('border-active');
    e.target.classList.add('border-active');
    subscriptionWidget.classList.remove('hidden');
    buyButton_and_variants.style.width= "100%";
    hideVariantOptions();
  });
  
  simpleOptionBtn.addEventListener('click', (e) => {
    shippingBtn.classList.remove('border-active');
    e.target.classList.add('border-active');
    subscriptionWidget.classList.add('hidden');
    buyButton_and_variants.style.width= "67%";
    showVariantOptions();
  });
}

function hideVariantOptions() {
  document.querySelectorAll(variantValuesSelector).forEach((value) => {
    value.classList.add('hidden');
  });
}

function showVariantOptions() {
  document.querySelectorAll(variantValuesSelector).forEach((value) => {
    value.classList.remove('hidden');
  });
}

// Main observer for initial load and dynamic changes
const observer = new MutationObserver((mutations) => {
  let needsUpdate = false;
  
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        // Check if variant options or subscription widget changed
        if (node.matches(variantValuesSelector) || 
            node.closest(variantValuesSelector) || 
            node.matches('.appstle_sub_widget')) {
            node.classList.add('hidden');    
          needsUpdate = true;
        }
      }
    });
  });
  
  if (needsUpdate) {
    initializeElements();
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', initializeElements);

// Observe the product info container for changes
const productInfoContainer = document.querySelector('.product__info-container');
if (productInfoContainer) {
  observer.observe(productInfoContainer, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', () => {
  let button = document.querySelector('.custom-add-to-cart');
  button.addEventListener('click', ()=> {
    window.HS_SLIDE_CART_ADD_TO_CART({ id: 50600356348192, quantity: 5 });
  })

});


// timer js

